import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TransferRequestListModel, TransferRequestModel } from '../models/app.models';

/**
 * CRUD nad `/api/transfer-requests` (viz TransferRequestsController) — fronta veřejně podaných
 * požadavků na přestup + akce oddělení (zamítnout / propojit s vytvořeným přestupem). Vzor podle
 * TodoService — jedna metoda na jeden endpoint, bez lokálního cache/state (to drží
 * RequestListComponent pro seznam a AssistantBadgeService pro odznak).
 */
@Injectable({
  providedIn: 'root'
})
export class TransferRequestService {
  private apiUrl = '/api/transfer-requests';

  constructor(private http: HttpClient) {
  }

  /** Fronta otevřených požadavků (BE vrací jen Status New/Validated), nejnovější první. */
  getQueue(): Observable<TransferRequestListModel[]> {
    return this.http.get<TransferRequestListModel[]>(this.apiUrl);
  }

  getById(id: number): Observable<TransferRequestModel> {
    return this.http.get<TransferRequestModel>(`${this.apiUrl}/${id}`);
  }

  reject(id: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/reject`, {});
  }

  markConverted(id: number, transferId: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/mark-converted`, { transferId });
  }

  /**
   * Lehký "COUNT" pro odznak (viz AssistantBadgeService) — BE zatím nemá dedikovaný
   * open-count endpoint jako Todo/Question, ale fronta už BE-side vrací jen otevřené
   * požadavky (New/Validated), takže délka pole je bezpečný ekvivalent.
   */
  getOpenCount(): Observable<number> {
    return this.getQueue().pipe(map(queue => queue.length));
  }
}
